<section class="checkout-delivery" *ngIf="form" [formGroup]="form">
  <p class="checkout-delivery__eyebrow" i18n="@@checkout.delivery.eyebrow">送貨及聯絡資料 Delivery &amp; Contact</p>

  <!-- Notice -->
  <div class="checkout-delivery__notice">
    <p i18n="@@checkout.delivery.notice">
      *每日下午4時或之後的訂單，將於下一個工作天處理。<br>
      *於網上商店單次購物滿港幣1400元 (折扣後總額)，享免費外送到門服務一次 (除不配送地區外)。
    </p>
  </div>

  <!-- Method radios -->
  <p class="checkout-delivery__label" i18n="@@checkout.delivery.methodLabel">送貨方式</p>
  <div class="checkout-delivery__methods">
    <button type="button"
            class="checkout-delivery__method"
            [class.is-active]="formType === 'PICKUP'"
            (click)="selectType('PICKUP')">
      <p class="checkout-delivery__method-title">
        <span class="checkout-delivery__radio">{{ formType === 'PICKUP' ? '◉' : '○' }}</span> <ng-container i18n="@@checkout.delivery.method.pickup">自取</ng-container>
      </p>
    </button>
    <button type="button"
            class="checkout-delivery__method"
            [class.is-active]="formType === 'DELIVERY'"
            (click)="selectType('DELIVERY')">
      <p class="checkout-delivery__method-title">
        <span class="checkout-delivery__radio">{{ formType === 'DELIVERY' ? '◉' : '○' }}</span> <ng-container i18n="@@checkout.delivery.method.delivery">送貨</ng-container>
      </p>
    </button>
  </div>
  <!-- 不需要選擇地址 (COUPON_ONLY) temporarily hidden -->
  <button *ngIf="false" type="button"
          class="checkout-delivery__method checkout-delivery__method--wide"
          [class.is-active]="formType === 'COUPON_ONLY'"
          (click)="selectType('COUPON_ONLY')">
    <p class="checkout-delivery__method-title">
      <span class="checkout-delivery__radio">{{ formType === 'COUPON_ONLY' ? '◉' : '○' }}</span> <ng-container i18n="@@checkout.delivery.method.couponOnly">不需要選擇地址</ng-container>
    </p>
    <p class="checkout-delivery__method-hint" i18n="@@checkout.delivery.method.couponOnly.hint">(購買優惠券專用)</p>
  </button>

  <!-- DELIVERY / PICKUP: date + time -->
  <ng-container *ngIf="formType !== 'COUPON_ONLY'">
    <div class="checkout-delivery__divider"></div>

    <p class="checkout-delivery__label">
      <ng-container *ngIf="formType === 'PICKUP'; else deliveryDateLabel" i18n="@@checkout.delivery.datePickup">預計自取日期</ng-container>
      <ng-template #deliveryDateLabel><ng-container i18n="@@checkout.delivery.dateDelivery">預計送貨日期</ng-container></ng-template>
    </p>
    <div class="checkout-delivery__row checkout-delivery__row--date">
      <div class="checkout-delivery__input-wrap">
        <div class="checkout-delivery__field-wrap">
          <input type="text"
                 class="checkout-delivery__input checkout-delivery__input--with-icon"
                 formControlName="date"
                 i18n-placeholder="@@checkout.delivery.date.placeholder"
                 placeholder="*選擇日期"
                 readonly
                 [matDatepicker]="picker"
                 [matDatepickerFilter]="dateFilter"
                 [min]="minDate"
                 (click)="picker.open()"
                 (dateChange)="onDateChange($event)">
          <button type="button" class="checkout-delivery__field-icon" (click)="picker.open()" i18n-aria-label="@@checkout.delivery.date.aria" aria-label="Open calendar">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <rect x="3" y="4" width="18" height="18" rx="2"/>
              <path d="M16 2v4M8 2v4M3 10h18"/>
            </svg>
          </button>
          <mat-datepicker #picker></mat-datepicker>
        </div>
        <div class="checkout-delivery__error" *ngIf="shouldShowError('date')" i18n="@@checkout.delivery.error.dateRequired">必須填寫日期</div>
      </div>

      <div class="checkout-delivery__input-wrap">
        <div class="checkout-delivery__field-wrap">
          <select class="checkout-delivery__input checkout-delivery__select"
                  formControlName="time">
            <option value="" disabled selected hidden i18n="@@checkout.delivery.time.default">*選擇時間</option>
            <option *ngFor="let slot of timeSlots" [value]="slot">{{ slot.substring(0, 5) }}</option>
          </select>
        </div>
        <div class="checkout-delivery__error" *ngIf="shouldShowError('time')" i18n="@@checkout.delivery.error.timeRequired">必須填寫時間</div>
      </div>
    </div>

    <!-- Pickup store -->
    <ng-container *ngIf="formType === 'PICKUP'">
      <p class="checkout-delivery__label" i18n="@@checkout.delivery.pickupStore">選擇自取分店</p>
      <div class="checkout-delivery__input-wrap">
        <div class="checkout-delivery__field-wrap">
          <select class="checkout-delivery__input checkout-delivery__select"
                  formControlName="store">
            <option value="" disabled selected hidden i18n="@@checkout.delivery.store.default">*選擇分店</option>
            <option *ngFor="let s of stores" [value]="s">{{ s }}</option>
          </select>
        </div>
        <div class="checkout-delivery__error" *ngIf="shouldShowError('store')" i18n="@@checkout.delivery.error.required">必須填寫</div>
      </div>
    </ng-container>
  </ng-container>

  <!-- Contact (always) -->
  <div class="checkout-delivery__divider"></div>
  <p class="checkout-delivery__label" i18n="@@checkout.delivery.contactHeading">聯絡資料</p>

  <div class="checkout-delivery__input-wrap">
    <input type="email"
           class="checkout-delivery__input"
           formControlName="email"
           i18n-placeholder="@@checkout.delivery.email.placeholder"
           placeholder="*電郵地址 (訂單確認通知將會發送到你的電郵地址)">
    <div class="checkout-delivery__error" *ngIf="shouldShowError('email')" i18n="@@checkout.delivery.error.required">必須填寫</div>
  </div>

  <div class="checkout-delivery__row">
    <div class="checkout-delivery__input-wrap">
      <input type="text"
             class="checkout-delivery__input"
             formControlName="name"
             i18n-placeholder="@@checkout.delivery.name.placeholder"
             placeholder="*姓名">
      <div class="checkout-delivery__error" *ngIf="shouldShowError('name')" i18n="@@checkout.delivery.error.required">必須填寫</div>
    </div>
    <div class="checkout-delivery__input-wrap">
      <input type="tel"
             class="checkout-delivery__input"
             formControlName="contact"
             i18n-placeholder="@@checkout.delivery.phone.placeholder"
             placeholder="*聯絡電話"
             maxlength="8">
      <div class="checkout-delivery__error" *ngIf="shouldShowError('contact')">
        <ng-container *ngIf="ctrl('contact')?.errors?.required; else lenErr" i18n="@@checkout.delivery.error.required">必須填寫</ng-container>
        <ng-template #lenErr><ng-container i18n="@@checkout.delivery.error.phoneLen">電話必須是八位數</ng-container></ng-template>
      </div>
    </div>
  </div>

  <!-- Delivery address (DELIVERY only) -->
  <ng-container *ngIf="formType === 'DELIVERY'">
    <div class="checkout-delivery__divider"></div>
    <p class="checkout-delivery__label" i18n="@@checkout.delivery.addressHeading">送貨地址</p>

    <div class="checkout-delivery__input-wrap">
      <input type="text"
             class="checkout-delivery__input"
             formControlName="addressLine1"
             i18n-placeholder="@@checkout.delivery.addressLine1.placeholder"
             placeholder="*送貨地址第一行">
      <div class="checkout-delivery__error" *ngIf="shouldShowError('addressLine1')" i18n="@@checkout.delivery.error.required">必須填寫</div>
    </div>

    <div class="checkout-delivery__input-wrap">
      <input type="text"
             class="checkout-delivery__input"
             formControlName="addressLine2"
             i18n-placeholder="@@checkout.delivery.addressLine2.placeholder"
             placeholder="送貨地址第二行">
    </div>

    <div class="checkout-delivery__input-wrap">
      <input type="text"
             class="checkout-delivery__input"
             formControlName="district"
             i18n-placeholder="@@checkout.delivery.district.placeholder"
             placeholder="*地區">
      <div class="checkout-delivery__error" *ngIf="shouldShowError('district')" i18n="@@checkout.delivery.error.required">必須填寫</div>
    </div>
  </ng-container>
</section>
